import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { cloneDeep } from "lodash";
import { modeEnum } from "typeConstants/preferenceTypes";
import MGrid, {
  ACTION_ADD,
  ACTION_DELETE,
  ACTION_EDIT,
  ACTION_CANCEL,
  FILTER_TYPE_TEXT,
} from "components/Shared/MGrid.tsx";
import MGridLayout from "components/Shared/MGridLayout";
import { DATA_TYPE_BOOLEAN } from "typeConstants/dataTypes";
import { LoginActivity } from "components/User";
import UserInformation from "components/User/UserInformation";
import { savePreference, loadPreference } from "actions/preferences";
import * as actions from "actions/user";
import * as underwriterActions from "actions/underwriter";
import { MSpinner } from "components/Shared";
import TwoFactorSettings from "components/User/Profile/TwoFactorSettings";
import MDialog, { ACTION_CLOSE, ACTION_APPLY } from "components/Shared/MDialog.tsx";
import MSelect from "components/Shared/MSelect";
import Roles from "components/User/Roles";
import {
  AUTHENTICATION_EDIT,
  AUTHENTICATION_COMPANIES_EDIT,
  UNDERWRITER_EDIT,
  HAS_UNDERWRITER,
} from "typeConstants/rights";
import { getMajorCompanies } from "actions/customer";
import { addToast as snackbarToast } from "actions/snackbar";
import { userHasRight } from "selectors/rights";
import responseHandler from "responseHandler";
import UserUnderwriters from "components/User/UserUnderwriters.tsx";
import { defaultHeightStyle } from "styles/sharedStyles";

class InternetUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roleOverrides: { mode: modeEnum.READ_ONLY, selectedIndexes: [] },
      agencyCodes: { mode: modeEnum.READ_ONLY, selectedIndexes: [] },
      authorizedCompanies: { mode: modeEnum.READ_ONLY, selectedIndexes: [] },
      authMajorCompaniesDialogBoxVisible: false,
      authCompaniesDialogBoxVisible: false,
      addUnderwriterDialogBoxVisible: false,
      deleteUnderwriterDialogBoxVisible: false,
      agencyDialogBoxVisible: false,
      deleteDialogBoxVisible: false,
      accountNumber: "",
      customerName: "",
      type: "",
      options: null,
      isFetchingallMajorCompaniesList: false,
      majorCompanyOptions: null,
      majorCompany: null,
      internetUserId: "",
      agencyCode: "",
      agencyType: "",
      gridToDeleteFrom: "",
      right: null,
      isRightEnabled: false,
      roleDialogBoxVisible: false,
      editedUnderwriterDto: null,
    };

    this.getGridCards = this.getGridCards.bind(this);
    this.getActionButtons = this.getActionButtons.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.authCompaniesDialogBox = this.authCompaniesDialogBox.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleAccountNumberSelection = this.handleAccountNumberSelection.bind(this);
    this.handleCustomerNameSelection = this.handleCustomerNameSelection.bind(this);
    this.handleTypeSelection = this.handleTypeSelection.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
    this.handleAddConfirm = this.handleAddConfirm.bind(this);
    this.handleAddAuthorizedCompanyConfirm = this.handleAddAuthorizedCompanyConfirm.bind(this);
    this.handleAddMajorCompanyConfirm = this.handleAddMajorCompanyConfirm.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.deleteDialogBox = this.deleteDialogBox.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.agencyDialogBox = this.agencyDialogBox.bind(this);
    this.roleDialogBox = this.roleDialogBox.bind(this);
    this.getInternetUserId = this.getInternetUserId.bind(this);
    this.fetchAllCustomersIfNeeded = this.fetchAllCustomersIfNeeded.bind(this);
    this.fetchAllMajorCompaniesIfNeeded = this.fetchAllMajorCompaniesIfNeeded.bind(this);
  }

  componentDidMount() {
    const { getLoginStatistics, getUser, getUnderwriters, getAuthorizedUnderwriters } = this.props;
    let internetUserId = this.getInternetUserId();
    getLoginStatistics(internetUserId);
    getUser(internetUserId);
    getUnderwriters(internetUserId);
    getAuthorizedUnderwriters(internetUserId);
    this.fetchAllCustomersIfNeeded();
    this.fetchAllMajorCompaniesIfNeeded();
  }

  componentDidUpdate(prevProps) {
    const { allCustomers, allMajorCompanies, isFetchingAllCustomersList } =
      this.props;
    const { isFetchingallMajorCompaniesList } = this.state;
    let internetUserId = this.getInternetUserId();
    if (
      !allCustomers &&
      !isFetchingAllCustomersList
    ) {
      this.fetchAllCustomersIfNeeded();
    }
    if (
      !allMajorCompanies &&
      !isFetchingallMajorCompaniesList
    ) {
      this.fetchAllMajorCompaniesIfNeeded();
    }
    if (
      (!this.props.updatingUser && prevProps.updatingUser) ||
      (!this.props.updatingUserInfo && prevProps.updatingUserInfo)
    ) {
      this.props.getUser(internetUserId);
      this.props.getUnderwriters(internetUserId);
      this.props.getAuthorizedUnderwriters(internetUserId);
    }
    if (!this.state.options && this.props.allCustomers?.length) {
      let options = {
        accountNumber: this.props.allCustomers.map((x) => x.accountNumber.toString()),
        customerName: this.props.allCustomers.map((x) => x.customerName),
        type: [...new Set(this.props.allCustomers.map((x) => x.type))],
      };
      this.setState({ options: options });
    }
    if (!this.state.majorCompanyOptions && this.props.allMajorCompanies?.length) {
      let majorCompanyOptions = this.props.allMajorCompanies.map((x) => {
        return {
          label: x.companyName,
          value: x,
        };
      });
      this.setState({ majorCompanyOptions: majorCompanyOptions, isFetchingallMajorCompaniesList: false });
    }
    if (this.props.internetUserOverride !== prevProps.internetUserOverride) {
      this.setState({ internetUserId: this.props.internetUserOverride });
      this.props.getLoginStatistics(this.props.internetUserOverride);
      this.props.getUser(this.props.internetUserOverride);
      this.props.getUnderwriters(this.props.internetUserOverride);
      this.props.getAuthorizedUnderwriters(internetUserId);
    }
  }

  canEditCompanies = this.props.profile.rights.includes(AUTHENTICATION_COMPANIES_EDIT);

  fetchAllCustomersIfNeeded() {
    const { getAllCustomers, allCustomers } = this.props;
    if (!allCustomers && this.canEditCompanies) {
      getAllCustomers();
    }
  }

  fetchAllMajorCompaniesIfNeeded() {
    const { getAllMajorCompanies, allMajorCompanies } = this.props;
    if (!allMajorCompanies && this.canEditCompanies) {
      getAllMajorCompanies();
      this.setState({ isFetchingallMajorCompaniesList: true });
    }
  }

  getInternetUserId() {
    if (this.props.internetUserOverride) {
      return this.props.internetUserOverride;
    } else if (
      this.props.location.state &&
      this.props.location.state.user &&
      this.props.location.state.user.internetUserId
    ) {
      return this.props.location.state.user.internetUserId;
    } else if (this.props.location.state && this.props.location.state.internetUserId) {
      return this.props.location.state.internetUserId;
    } else if (this.props.internetUserId) {
      return this.props.internetUserId;
    }
  }

  getGridCards() {
    const cards = [
      {
        key: "roleOverrides",
        headerText: "Role Overrides",
        gridCols: [
          {
            key: "userRight",
            name: "Rights",
            width: 300,
            dataSource: "userRight",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
          },
          {
            key: "isEnabled",
            name: "Enabled",
            width: 75,
            dataSource: "isEnabled",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
            dataType: DATA_TYPE_BOOLEAN,
          },
        ],
        data: this.props.internetUser.userRights,
        visible: true,
        editable: true,
        wrapperStyle: { height: "400px" },
      },
      {
        key: "agencyCodes",
        headerText: "Agency Codes",
        gridCols: [
          {
            key: "agencyCode",
            name: "Agency Code",
            width: 150,
            dataSource: "agencyCode",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
          },
          {
            key: "type",
            name: "Type",
            width: 70,
            dataSource: "type",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
          },
        ],
        data: this.props.internetUser.agencyCodes,
        visible: this.props.internetUser.hasAgentCodes,
        editable: true,
      },
      {
        key: "authorizedCompanies",
        headerText: "Authorized Companies",
        gridCols: [
          {
            key: "accountNumber",
            name: "Account #",
            width: 80,
            dataSource: "accountNumber",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
          },
          {
            key: "customerName",
            name: "Customer Name",
            width: 300,
            dataSource: "customerName",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
          },
          {
            key: "type",
            name: "Type",
            width: 50,
            dataSource: "type",
            resizable: false,
            filterType: FILTER_TYPE_TEXT,
          },
        ],
        data: this.props.internetUser.customers,
        visible: this.props.internetUser.hasAccountLimitations,
        editable: true,
        wrapperStyle: defaultHeightStyle,
      },
    ];

    return cards;
  }

  handleAddClick(key) {
    switch (key) {
      case "roleOverrides":
        this.setState({ roleDialogBoxVisible: true });
        break;
      case "agencyCodes":
        this.setState({ agencyDialogBoxVisible: true });
        break;
      case "authorizedCompanies":
        this.setState({ authCompaniesDialogBoxVisible: true });
        break;
    }
  }

  handleAccountNumberSelection(accNum) {
    let customer = accNum ? this.props.allCustomers?.find((x) => x.accountNumber.toString() === accNum) : null;
    this.setState({
      accountNumber: accNum || "",
      customerName: customer ? customer.customerName : "",
      type: customer ? customer.type : "",
    });
  }

  handleCustomerNameSelection(custName, change) {
    this.setState({ customerName: custName });
    if (!change) {
      let customer = this.props.allCustomers?.find((x) => x.customerName === custName);
      if (customer) {
        this.setState({ accountNumber: customer.accountNumber.toString() });
        this.setState({ type: customer.type });
      }
    }
  }

  handleMajorCustomerNameSelection(majorCompany) {
    this.setState({ majorCompany: majorCompany });
  }

  handleTypeSelection(type) {
    this.setState({ type: type });
  }

  handleDisable(key) {
    const { accountNumber, customerName, type, agencyCode, agencyType, right, majorCompany } = this.state;
    let customer;
    switch (key) {
      case "roleOverrides":
        if (!right) return true;
        return false;
      case "agencyCodes":
        if (!agencyCode || !agencyType) return true;
        return false;
      case "authorizedCompanies":
        // are all three set?
        if (!accountNumber || !customerName || !type) return true;
        // find the customer from all customers based on account number
        customer = this.props.allCustomers?.find((x) => x.accountNumber.toString() === accountNumber);
        if (!customer) return true;
        // see if all three values match to a valid customer
        if (customer.accountNumber != accountNumber || customer.customerName != customerName || customer.type != type)
          return true;
        return false;
      case "authorizedCompaniesByMajorCompany":
        if (!majorCompany) return true;
        return false;
    }
  }

  // We should probably just split these off into separate functions at some point. I don't really see a point in doing it this way
  handleAddConfirm(key) {
    switch (key) {
      case "roleOverrides":
        if (this.state.right && this.state.right.value) {
          this.props.addRight(this.props.internetUserId, this.state.right.value, this.state.isRightEnabled);
        }
        this.setState({ roleDialogBoxVisible: false, right: null, isRightEnabled: false });
        break;
      case "agencyCodes":
        this.props.addAgency(this.props.internetUserId, this.state.agencyCode, this.state.agencyType);
        this.setState({ agencyDialogBoxVisible: false });
        break;
    }
  }

  handleAddAuthorizedCompanyConfirm() {
    this.props.addCompany(this.props.internetUserId, this.state.accountNumber, this.state.type);
    this.props.makeSuccessToast("Authorized company added successfully.");
    this.setState({ authCompaniesDialogBoxVisible: false, accountNumber: "", customerName: "", type: "" });
  }

  handleAddMajorCompanyConfirm() {
    const selectedMajorCompany = this.state.majorCompany;
    const internetUser = this.props.internetUser;
    if (selectedMajorCompany?.id && this.props.allCustomers) {
      // get customers with that major company id
      let majorCustomerCompanies = this.props.allCustomers.filter(
        (x) => x.majorCompanyId === selectedMajorCompany.id,
      );
      // filter out customers that the user already has
      majorCustomerCompanies = majorCustomerCompanies.filter(
        (x) => internetUser.customers.findIndex((y) => y.accountNumber === x.accountNumber) < 0,
      );
      // call to add each customer
      majorCustomerCompanies.map((x) =>
        this.props.addCompany(this.props.internetUserId, x.accountNumber, x.type),
      );
      if (!majorCustomerCompanies.length) {
        this.props.addToast(
          `This user already has all the customer accounts under ${selectedMajorCompany.companyName}.`,
          "warning",
        );
      } else {
        // This is actually kind of bogus because we're assuming all the calls succeeded and we don't know how many actually succeeded. We should fix this at some point to give more accurate feedback
        this.props.makeSuccessToast(`Added ${majorCustomerCompanies.length} customer accounts.`);
      }
    }
    this.setState({ authMajorCompaniesDialogBoxVisible: false, majorCompany: null });
  }

  authCompaniesDialogBox() {
    return (
      <MDialog
        className="authcompanies-dialog-box"
        title="Add Auth Company"
        visible={this.state.authCompaniesDialogBoxVisible}
        onHide={() => this.setState({ authCompaniesDialogBoxVisible: false })}
        sx={{ width: 320 }}
        contentActions={[
          <Button key="cancel" onClick={() => this.setState({ authCompaniesDialogBoxVisible: false })}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            onClick={this.handleAddAuthorizedCompanyConfirm}
            disabled={this.handleDisable("authorizedCompanies")}
          >
            Confirm
          </Button>,
        ]}
      >
        {this.state.options ? (
          <>
            <Autocomplete
              id="auth-company-autocomplete-1"
              options={this.state.options.accountNumber || []}
              value={this.state.accountNumber || null}
              onChange={(e, accNum) => this.handleAccountNumberSelection(accNum)}
              sx={{ mb: 2 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Account #"
                  placeholder="Start typing a customer number"
                  required
                  error={!this.state.accountNumber}
                  helperText={!this.state.accountNumber ? "An account is required!" : ""}
                  variant="standard"
                  fullWidth
                />
              )}
            />
            <TextField
              label="Customer Name"
              value={this.state.customerName || ""}
              variant="standard"
              fullWidth
              InputProps={{ readOnly: true }}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              id="auth-company-autocomplete-3"
              options={this.state.options.type || []}
              value={this.state.type}
              inputValue={this.state.type || ""}
              onChange={(e, type) => this.handleTypeSelection(type)}
              onInputChange={(e, type, reason) => {
                if (reason === "input") this.setState({ type: type || "" });
              }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Type"
                  placeholder="H"
                  required
                  error={!this.state.type}
                  helperText={!this.state.type ? "A type is required!" : ""}
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </>
        ) : (
          <MSpinner />
        )}
      </MDialog>
    );
  }

  authMajorCompaniesDialogBox() {
    return (
      <MDialog
        className="majorcompany-dialog-box"
        title="Add Auth Companies by Major Company"
        visible={this.state.authMajorCompaniesDialogBoxVisible}
        onHide={() => this.setState({ authMajorCompaniesDialogBoxVisible: false })}
        sx={{ width: 400 }}
        contentActions={[
          <Button key="cancel" onClick={() => this.setState({ authMajorCompaniesDialogBoxVisible: false })}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            onClick={() => this.handleAddMajorCompanyConfirm()}
            disabled={this.handleDisable("authorizedCompaniesByMajorCompany")}
          >
            Confirm
          </Button>,
        ]}
      >
        {/* When adding by major company it requires the company list to exist, so check for that here too */}
        {this.state.isFetchingallMajorCompaniesList || this.props.isFetchingAllCustomersList ? (
          <MSpinner />
        ) : (
          <MSelect
            label="Major Company Name"
            placeholder="Select a major company"
            options={this.state.majorCompanyOptions || []}
            value={
              this.state.majorCompany
                ? { label: this.state.majorCompany.companyName, value: this.state.majorCompany }
                : null
            }
            onChange={(option) => this.handleMajorCustomerNameSelection(option?.value)}
            isClearable={false}
            getMenuPortalTarget={() => document.querySelector(".majorcompany-dialog-box")}
          />
        )}
      </MDialog>
    );
  }

  agencyDialogBox() {
    return (
      <div className="agency-dialog-box">
        <Dialog
          id="simple-action-dialog"
          open={this.state.agencyDialogBoxVisible}
          onClose={() => this.setState({ agencyDialogBoxVisible: false })}
        >
          <DialogTitle>Add Agency Code</DialogTitle>
          <DialogContent>
            <TextField
              variant="standard"
              id="floating-label-error-text-field"
              label="Agency Code"
              required
              onChange={(e) => this.setState({ agencyCode: e.target.value })}
              value={this.state.agencyCode}
            />
            <TextField
              select
              variant="standard"
              id="select-field-1"
              label="Type"
              style={{ width: "100%" }}
              required
              value={this.state.agencyType}
              onChange={(e) => this.setState({ agencyType: e.target.value })}
            >
              <MenuItem value="H">Home</MenuItem>
              <MenuItem value="A">Auto</MenuItem>
              <MenuItem value="I">ITV</MenuItem>
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ agencyDialogBoxVisible: false })}>Cancel</Button>
            <Button onClick={() => this.handleAddConfirm("agencyCodes")} disabled={this.handleDisable("agencyCodes")}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  roleDialogBox() {
    const { getAllRights, allRights, internetUser } = this.props;
    if (internetUser.canEditUser && (!allRights || allRights.length === 0)) getAllRights();
    return (
      <MDialog
        title="Add Right"
        className="role-override-mdialog"
        actions={[
          { code: ACTION_APPLY, onClick: () => this.handleAddConfirm("roleOverrides") },
          {
            code: ACTION_CLOSE,
            onClick: () => this.setState({ roleDialogBoxVisible: false, right: null, isRightEnabled: false }),
          },
        ]}
        children={[
          <MSelect
            key="role-overrides-dropdown"
            isClearable={false}
            onChange={(input) => this.setState({ right: input })}
            options={this.props.allRights}
            getMenuPortalTarget={() => document.querySelector(".role-override-mdialog")}
          />,
          <FormControlLabel
            key="role-override-checkbox"
            control={<Checkbox onChange={(e) => this.setState({ isRightEnabled: e.target.checked })} />}
            label="Enable"
          />,
        ]}
        visible={this.state.roleDialogBoxVisible}
      />
    );
  }
  handleEditClick(key) {
    let newCard = cloneDeep(this.state[key]);
    newCard.mode = modeEnum.EDIT;
    this.setState({ [key]: newCard });
  }

  handleCancelClick(key) {
    let newCard = cloneDeep(this.state[key]);
    newCard.mode = modeEnum.READ_ONLY;
    this.setState({ [key]: newCard });
  }

  handleDeleteClick(key) {
    this.setState({ gridToDeleteFrom: key });
    this.setState({ deleteDialogBoxVisible: true });
  }

  handleAddMajorCompanyClick() {
    this.setState({
      authMajorCompaniesDialogBoxVisible: true,
    });
  }

  getActionButtons(key, mode) {
    let actionButtons = null;
    switch (mode) {
      case modeEnum.READ_ONLY:
        // 'add' and 'edit'
        switch (key) {
          case "authorizedCompanies": {
            return [
              { code: ACTION_ADD, onClick: () => this.handleAddClick(key) },
              { code: ACTION_EDIT, onClick: () => this.handleEditClick(key) },
              {
                code: ACTION_ADD,
                icon: "group_add",
                helpText: "Add Companies from a Major Company",
                onClick: () => this.handleAddMajorCompanyClick(key),
              },
            ];
          }
          default: {
            return [
              { code: ACTION_ADD, onClick: () => this.handleAddClick(key) },
              { code: ACTION_EDIT, onClick: () => this.handleEditClick(key) },
            ];
          }
        }

      case modeEnum.EDIT: {
        // 'cancel', 'delete', 'add'
        actionButtons = [
          { code: ACTION_CANCEL, onClick: () => this.handleCancelClick(key) },
          { code: ACTION_ADD, onClick: () => this.handleAddClick(key) },
        ];
        if (this.state[key].selectedIndexes.length > 0) {
          actionButtons.push({ code: ACTION_DELETE, onClick: () => this.handleDeleteClick(key) });
        }
        return actionButtons;
      }
      default:
        return [
          { code: ACTION_ADD, onClick: () => this.handleAddClick(key) },
          { code: ACTION_EDIT, onClick: () => this.handleEditClick(key) },
        ];
    }
  }

  handleDeleteConfirm() {
    let key = this.state.gridToDeleteFrom;
    let card;
    switch (key) {
      case "roleOverrides":
        this.state[key].selectedIndexes.map((index) =>
          this.props.deleteRight(this.props.internetUserId, this.props.internetUser.userRights[index].userRight),
        );
        card = cloneDeep(this.state[key]);
        card.selectedIndexes = [];
        this.setState({ deleteDialogBoxVisible: false, [key]: card });
        break;
      case "agencyCodes":
        this.state[key].selectedIndexes.map((index) =>
          this.props.deleteAgency(
            this.props.internetUserId,
            this.props.internetUser.agencyCodes[index].agencyCode,
            this.props.internetUser.agencyCodes[index].type,
          ),
        );
        card = cloneDeep(this.state[key]);
        card.selectedIndexes = [];
        this.setState({ deleteDialogBoxVisible: false, [key]: card });
        break;
      case "authorizedCompanies":
        this.state[key].selectedIndexes.map((index) =>
          this.props.deleteCompany(this.props.internetUserId, this.props.internetUser.customers[index].accountNumber),
        );
        card = cloneDeep(this.state[key]);
        card.selectedIndexes = [];
        this.setState({ deleteDialogBoxVisible: false, [key]: card });
        break;
    }
  }

  deleteDialogBox() {
    return (
      <Dialog
        id="simple-action-dialog"
        open={this.state.deleteDialogBoxVisible}
        onClose={() => this.setState({ deleteDialogBoxVisible: false })}
      >
        <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button onClick={() => this.setState({ deleteDialogBoxVisible: false })}>Cancel</Button>
          <Button onClick={this.handleDeleteConfirm}>Confirm</Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const coreDataLoading =
      this.props.isFetchingLoginStatistics ||
      this.props.isFetchingInternetUser ||
      this.props.loginStatistics == null ||
      Object.keys(this.props.internetUser).length === 0 ||
      this.props.internetUser.userRights == null ||
      this.props.isFetchingAllRightsList ||
      !this.props.allRights;
    if (coreDataLoading) return <MSpinner />;

    const needsCustomers =
      this.props.internetUser.hasAccountLimitations &&
      this.props.profile.rights.includes(AUTHENTICATION_COMPANIES_EDIT);
    let additionalDataLoading =
      needsCustomers &&
      (this.props.isFetchingAllCustomersList || !this.props.allCustomers || !this.props.allMajorCompanies);

    const needsUnderwriters = this.props.internetUser.hasUnderwriters;
    additionalDataLoading =
      additionalDataLoading &&
      needsUnderwriters &&
      (this.props.isFetchingUnderwriters ||
        !this.props.userUnderwriters ||
        this.props.isFetchingAuthorizedUnderwriters ||
        !this.props.authorizedUnderwriters);

    if (additionalDataLoading) return <MSpinner />;

    const { internetUser, verticalDisplay, profile } = this.props;
    let extraCards = this.getGridCards().filter((c) => c.visible);

    // Build rows for MGridLayout
    const rows = [];

    // Row 1: User Information + first extra cards (up to 2)
    const row1 = [
      {
        component: (
          <UserInformation
            userInformation={internetUser}
            internetUserId={this.getInternetUserId()}
            canEditUser={internetUser.canEditUser}
          />
        ),
        size: 4,
      },
    ];

    // Add extra cards (Role Overrides, Agency Codes, Authorized Companies)
    extraCards.forEach((card) => {
      row1.push({
        component: (
          <Card className="card-unnested profile-card card-style">
            <div className="grid-card" style={{ height: "100%" }}>
              <MGrid
                headerText={card.headerText}
                columnDefinitions={card.gridCols}
                data={card.data}
                isFetchingData={false}
                displayNumOfItemsFound={false}
                actions={card.editable ? this.getActionButtons(card.key, this.state[card.key].mode) : undefined}
                allowRowSelection={this.state[card.key].mode === modeEnum.EDIT}
                onRowSelectionChanged={(indexes) => {
                  let newCardObj = cloneDeep(this.state[card.key]);
                  newCardObj.selectedIndexes = indexes;
                  this.setState({ [card.key]: newCardObj });
                }}
                selectedRows={this.state[card.key].selectedIndexes}
                wrapperStyle={card.wrapperStyle}
              />
            </div>
          </Card>
        ),
        size: 4,
      });
    });
    rows.push(row1);

    // Row 2: Underwriters (if applicable) + Roles
    const row2 = [];
    if (internetUser.hasUnderwriters) {
      row2.push({ component: <UserUnderwriters />, size: 6 });
    }
    row2.push({
      component: (
        <Roles
          internetUserId={this.getInternetUserId()}
          canDelete={profile.rights.includes(AUTHENTICATION_EDIT)}
          primaryRole={internetUser.roleName}
        />
      ),
      size: 4,
    });
    rows.push(row2);

    // Row 3: Login Activity + Two Factor Settings (if applicable)
    const row3 = [{ component: <LoginActivity loginStatistics={this.props.loginStatistics} />, size: 6 }];
    if (profile.rights.some((s) => s === "User Multi-Factor Settings Edit")) {
      row3.push({
        component: <TwoFactorSettings canAdd={false} internetUserId={this.props.internetUserId} />,
        size: 6,
      });
    }
    rows.push(row3);

    return (
      <>
        {this.authCompaniesDialogBox()}
        {this.authMajorCompaniesDialogBox()}
        {this.agencyDialogBox()}
        {this.roleDialogBox()}
        {this.deleteDialogBox()}
        <MGridLayout verticalDisplay={verticalDisplay} rows={rows} padding={verticalDisplay ? 0 : 1} />
      </>
    );
  }
}

InternetUser.propTypes = {
  internetUserOverride: PropTypes.number,
  verticalDisplay: PropTypes.bool,
  loginStatistics: PropTypes.object,
  getLoginStatistics: PropTypes.func.isRequired,
  isFetchingLoginStatistics: PropTypes.bool.isRequired,
  internetUserId: PropTypes.number,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  internetUser: PropTypes.object,
  getUser: PropTypes.func.isRequired,
  isFetchingInternetUser: PropTypes.bool.isRequired,
  getAllMajorCompanies: PropTypes.func.isRequired,
  allMajorCompanies: PropTypes.array,
  getAllCustomers: PropTypes.func.isRequired,
  isFetchingAllCustomersList: PropTypes.bool.isRequired,
  allCustomers: PropTypes.array.isRequired,
  addCompany: PropTypes.func.isRequired,
  deleteCompany: PropTypes.func.isRequired,
  updatingUser: PropTypes.bool.isRequired,
  getUnderwriters: PropTypes.func.isRequired,
  isFetchingUnderwriters: PropTypes.bool.isRequired,
  userUnderwriters: PropTypes.array,
  getAuthorizedUnderwriters: PropTypes.func.isRequired,
  isFetchingAuthorizedUnderwriters: PropTypes.bool.isRequired,
  authorizedUnderwriters: PropTypes.array.isRequired,
  removeUnderwriterInternetUser: PropTypes.func.isRequired,
  addAgency: PropTypes.func.isRequired,
  deleteAgency: PropTypes.func.isRequired,
  allRights: PropTypes.array.isRequired,
  getAllRights: PropTypes.func.isRequired,
  addRight: PropTypes.func.isRequired,
  deleteRight: PropTypes.func.isRequired,
  isFetchingAllRightsList: PropTypes.bool.isRequired,
  profile: PropTypes.object,
  addToast: PropTypes.func,
  makeSuccessToast: PropTypes.func,
  canEditUnderwriters: PropTypes.bool,
  updatingUserInfo: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    loginStatistics: state.user.loginStatistics,
    isFetchingLoginStatistics: state.user.isFetchingLoginStatistics,
    internetUserId: state.user.internetUserId,
    isFetchingInternetUser: state.user.isFetchingInternetUser,
    internetUser: state.user.internetUser,
    preferences: state.preferences,
    isDisablingUser: state.user.isDisablingUser,
    isEnablingUser: state.user.isEnablingUser,
    isFetchingAllCustomersList: state.user.isFetchingAllCustomersList,
    allMajorCompanies: state.customer.majorCompanies,
    allCustomers: state.user.allCustomers,
    updatingUser: state.user.updatingUser,
    isFetchingAllRightsList: state.user.isFetchingAllRightsList,
    allRights: state.user.allRights,
    profile: state.user.profile,
    isFetchingUnderwriters: state.user.isFetchingUnderwriters,
    userUnderwriters: state.user.userUnderwriters,
    isFetchingAuthorizedUnderwriters: state.user.isFetchingAuthorizedUnderwriters,
    authorizedUnderwriters: state.user.authorizedUnderwriters,
    updatingUserInfo: state.user.updatingUserInfo,
    canEditUnderwriters: userHasRight(UNDERWRITER_EDIT)(state),
    hasUnderwriters: userHasRight(HAS_UNDERWRITER)(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getLoginStatistics(internetUserId) {
    dispatch(actions.getLoginStatistics(internetUserId));
  },
  getUser(id) {
    dispatch(actions.getUser(id));
  },
  savePreference(code, value) {
    dispatch(savePreference(code, value));
  },
  loadPreference(code) {
    dispatch(loadPreference(code));
  },
  getAllCustomers() {
    dispatch(actions.getAllCustomers());
  },
  getAllMajorCompanies() {
    dispatch(getMajorCompanies());
  },
  addCompany(internetUserId, customerNumber) {
    dispatch(actions.addCompany(internetUserId, customerNumber));
  },
  deleteCompany(internetUserId, customerNumber) {
    dispatch(actions.deleteCompany(internetUserId, customerNumber));
  },
  getUnderwriters(internetUserId) {
    dispatch(underwriterActions.getUnderwriters(internetUserId));
  },
  getAuthorizedUnderwriters(internetUserId) {
    dispatch(underwriterActions.getAuthorizedUnderwriters(internetUserId));
  },
  removeUnderwriterInternetUser(underwriterId) {
    dispatch(underwriterActions.removeInternetUser(underwriterId));
  },
  addAgency(internetUserId, agencyCode, databaseType) {
    dispatch(actions.addAgency(internetUserId, agencyCode, databaseType));
  },
  deleteAgency(internetUserId, agencyCode, databaseType) {
    dispatch(actions.deleteAgency(internetUserId, agencyCode, databaseType));
  },
  getAllRights() {
    dispatch(actions.getAllRights());
  },
  addRight(internetUserId, rightName, isEnabled) {
    dispatch(actions.addRight(internetUserId, rightName, isEnabled));
  },
  deleteRight(internetUserId, rightName) {
    dispatch(actions.deleteRight(internetUserId, rightName));
  },
  addToast(message, type) {
    dispatch(
      snackbarToast({
        toast: {
          text: message,
          autohide: true,
          type: type,
        },
      }),
    );
  },
  makeSuccessToast(message) {
    responseHandler.customToast(message, "success", dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InternetUser));
